import type { AccountType, BusinessType, KycDocument } from "@/types/kyc";

export interface KycForm {
  businessType: BusinessType | "";
  legalBusinessName: string;
  tradeName: string;
  businessPan: string;
  gstNumber: string;
  yearOfIncorporation: string;
  natureOfBusiness: string;
  registeredAddress: string;
  city: string;
  state: string;
  pincode: string;
  businessMobile: string;
  businessEmail: string;
  ownerFullName: string;
  dateOfBirth: string;
  personalPan: string;
  aadhaarNumber: string;
  accountHolderName: string;
  accountNumber: string;
  confirmAccountNumber: string;
  ifsc: string;
  bankName: string;
  accountType: AccountType;
  docs: Record<string, KycDocument | null>;
}

export type FormErrors = Partial<Record<string, string>>;

export type SetField = (key: keyof KycForm, value: string) => void;

export type SetDoc = (key: string, doc: KycDocument | null) => void;

export const emptyForm: KycForm = {
  businessType: "",
  legalBusinessName: "",
  tradeName: "",
  businessPan: "",
  gstNumber: "",
  yearOfIncorporation: "",
  natureOfBusiness: "",
  registeredAddress: "",
  city: "",
  state: "",
  pincode: "",
  businessMobile: "",
  businessEmail: "",
  ownerFullName: "",
  dateOfBirth: "",
  personalPan: "",
  aadhaarNumber: "",
  accountHolderName: "",
  accountNumber: "",
  confirmAccountNumber: "",
  ifsc: "",
  bankName: "",
  accountType: "Savings",
  docs: {},
};

export const KYC_STEPS = [
  "Business Details",
  "Business Documents",
  "Personal Documents",
  "Bank Details",
];